import { twMerge } from "tailwind-merge";
import { PostVideoButton, type PostVideoButtonProps } from "./PostVideoButton";

export interface PostVideoFloatingBarProps extends Pick<PostVideoButtonProps, "onClick" | "disabled" | "data-testid"> {
  className?: string;
}

export const PostVideoFloatingBar = ({
  onClick,
  disabled,
  className,
  "data-testid": dataTestId,
}: PostVideoFloatingBarProps) => {
  return (
    <div
      className={twMerge(
        "pointer-events-none absolute inset-x-0 bottom-0 z-10 flex justify-center px-[16px] pb-[24px]",
        className,
      )}
    >
      <div className={twMerge("pointer-events-auto")}>
        <PostVideoButton variant="reverse" withShadow onClick={onClick} disabled={disabled} data-testid={dataTestId} />
      </div>
    </div>
  );
};
